<template>
  <div style="background:#fff; padding:20px;">
    <div style="margin-bottom:20px;">
      <a-select v-model="query.eventId" allow-clear placeholder="选择赛事" style="width:220px; margin-right:10px;" @change="handleEventChange">
        <a-select-option v-for="item in eventOptions" :key="item.id" :value="item.id">{{ item.title }}</a-select-option>
      </a-select>
      <a-select v-model="query.categoryId" allow-clear placeholder="选择组别" style="width:200px; margin-right:10px;" @change="handleQueryCategoryChange">
        <a-select-option v-for="item in categoryOptions" :key="item.id" :value="item.id">{{ item.categoryName }}</a-select-option>
      </a-select>
      <a-select v-model="query.roundId" allow-clear placeholder="选择轮次" style="width:180px; margin-right:10px;">
        <a-select-option v-for="item in roundOptions" :key="item.id" :value="item.id">{{ item.roundName }}{{ item.distance ? ` (${item.distance}m)` : '' }}</a-select-option>
      </a-select>
      <a-select v-model="query.published" allow-clear placeholder="发布状态" style="width:160px; margin-right:10px;">
        <a-select-option :value="0">未发布</a-select-option>
        <a-select-option :value="1">已发布</a-select-option>
      </a-select>
      <a-button type="primary" icon="search" @click="loadData">查询</a-button>
      <a-button type="primary" icon="plus" style="margin-left:10px;" @click="handleAdd">录入</a-button>
      <a-button style="margin-left:10px;" @click="handlePublish(1)">批量发布</a-button>
      <a-button style="margin-left:10px;" @click="handlePublish(0)">撤回发布</a-button>
    </div>

    <div style="margin-bottom:20px; padding:12px; background:#fafafa; border:1px dashed #ddd;">
      <a-upload :customRequest="handleImport" :showUploadList="false" accept=".xls,.xlsx" style="display:inline-block;">
        <a-button type="primary" icon="upload" title="上传成绩文件"></a-button>
      </a-upload>
      <a-button style="margin-left:10px;" icon="download" @click="downloadTemplate">下载示例文件</a-button>
      <span style="margin-left:12px; color:#999;">导入前请先选择赛事、组别和轮次，模板列顺序：名次、队伍名称、成绩、差值、备注</span>
    </div>

    <a-table :columns="columns" :data-source="data" rowKey="id" :loading="loading" :pagination="pagination" @change="handleTableChange">
      <span slot="published" slot-scope="text">
        <a-tag :color="text === 1 ? 'green' : 'orange'">{{ text === 1 ? '已发布' : '未发布' }}</a-tag>
      </span>
      <span slot="action" slot-scope="text, record">
        <a @click="handleEdit(record)">编辑</a>
        <a-divider type="vertical" />
        <a-popconfirm title="确定删除吗？" @confirm="handleDelete(record.id)">
          <a style="color:red;">删除</a>
        </a-popconfirm>
      </span>
    </a-table>

    <a-modal v-model="visible" :title="form.id ? '编辑成绩' : '录入成绩'" @ok="handleOk">
      <a-form-model ref="formRef" :model="form" :rules="rules" :label-col="{ span: 5 }" :wrapper-col="{ span: 16 }">
        <a-form-model-item label="赛事" prop="eventId">
          <a-select v-model="form.eventId" placeholder="请选择赛事" @change="loadCategoriesForForm">
            <a-select-option v-for="item in eventOptions" :key="item.id" :value="item.id">{{ item.title }}</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="组别" prop="categoryId">
          <a-select v-model="form.categoryId" placeholder="请选择组别" @change="handleFormCategoryChange">
            <a-select-option v-for="item in formCategoryOptions" :key="item.id" :value="item.id">{{ item.categoryName }}</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="轮次">
          <a-select v-model="form.roundId" placeholder="默认轮次" allow-clear>
            <a-select-option v-for="item in formRoundOptions" :key="item.id" :value="item.id">{{ item.roundName }}{{ item.distance ? ` (${item.distance}m)` : '' }}</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="名次" prop="rankNo">
          <a-input-number v-model="form.rankNo" :min="1" style="width:100%;" />
        </a-form-model-item>
        <a-form-model-item label="队伍名称" prop="teamId">
          <a-select v-model="form.teamId" placeholder="请先选择赛事和组别" :disabled="!form.eventId || !form.categoryId" show-search option-filter-prop="children">
            <a-select-option v-for="item in teamOptions" :key="item.teamId" :value="item.teamId">{{ item.teamName }}</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="航道号">
          <a-input-number v-model="form.laneNo" :min="1" style="width:100%;" placeholder="可选" />
        </a-form-model-item>
        <a-form-model-item label="参赛编号">
          <a-input v-model="form.bibNo" placeholder="可选" />
        </a-form-model-item>
        <a-form-model-item label="成绩" prop="resultTime">
          <a-input v-model="form.resultTime" placeholder="例如 3:24.67" />
        </a-form-model-item>
        <a-form-model-item label="差值">
          <a-input v-model="form.gapTime" placeholder="例如 +0.21" />
        </a-form-model-item>
        <a-form-model-item label="备注">
          <a-textarea v-model="form.remark" :rows="3" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import request from '@/utils/request'
import {
  deleteDragonResult,
  getDragonCategoryList,
  getDragonEventList,
  getDragonResultList,
  getDragonResultTeamOptions,
  getDragonRoundOptions,
  publishDragonResult,
  saveDragonResult
} from '@/api'

export default {
  data() {
    return {
      query: { eventId: undefined, categoryId: undefined, roundId: undefined, published: undefined },
      eventOptions: [],
      categoryOptions: [],
      formCategoryOptions: [],
      roundOptions: [],
      formRoundOptions: [],
      teamOptions: [],
      data: [],
      loading: false,
      visible: false,
      form: {},
      pagination: { current: 1, pageSize: 10, total: 0 },
      rules: {
        eventId: [{ required: true, message: '请选择赛事' }],
        categoryId: [{ required: true, message: '请选择组别' }],
        rankNo: [{ required: true, message: '请输入名次' }],
        teamId: [{ required: true, message: '请选择队伍名称' }],
        resultTime: [{ required: true, message: '请输入成绩' }]
      },
      columns: [
        { title: '赛事', dataIndex: 'eventTitle' },
        { title: '组别', dataIndex: 'categoryName' },
        { title: '轮次', dataIndex: 'roundId', width: 90, customRender: value => this.renderRoundName(value) },
        { title: '名次', dataIndex: 'rankNo', width: 70 },
        { title: '队伍名称', dataIndex: 'teamName' },
        { title: '航道', dataIndex: 'laneNo', width: 70 },
        { title: '编号', dataIndex: 'bibNo', width: 90 },
        { title: '成绩', dataIndex: 'resultTime', width: 110 },
        { title: '差值', dataIndex: 'gapTime', width: 100 },
        { title: '发布状态', dataIndex: 'published', width: 90, scopedSlots: { customRender: 'published' } },
        { title: '操作', key: 'action', width: 140, scopedSlots: { customRender: 'action' } }
      ]
    }
  },
  created() {
    this.loadEvents()
    this.loadData()
  },
  methods: {
    loadEvents() {
      getDragonEventList({ page: 1, pageSize: 200 }).then(res => {
        this.eventOptions = res.data.list || []
      })
    },
    handleEventChange(value) {
      this.query.categoryId = undefined
      this.query.roundId = undefined
      this.roundOptions = []
      this.loadCategories(value, 'query')
      this.loadRounds(value, null, 'query')
    },
    handleQueryCategoryChange(value) {
      this.query.roundId = undefined
      this.loadRounds(this.query.eventId, value, 'query')
    },
    renderRoundName(roundId) {
      if (!roundId) return '默认'
      const all = [...this.roundOptions, ...this.formRoundOptions]
      const hit = all.find(item => item.id === roundId)
      if (hit) {
        return hit.distance ? `${hit.roundName} (${hit.distance}m)` : hit.roundName
      }
      return '-'
    },
    loadRounds(eventId, categoryId, scene) {
      if (!eventId) {
        if (scene === 'form') this.formRoundOptions = []
        else this.roundOptions = []
        return
      }
      getDragonRoundOptions({ eventId, categoryId }).then(res => {
        const list = (res.data && res.data.list) || res.data || []
        if (scene === 'form') this.formRoundOptions = list
        else this.roundOptions = list
      })
    },
    loadCategories(eventId, scene) {
      if (!eventId) {
        if (scene === 'form') this.formCategoryOptions = []
        else this.categoryOptions = []
        return
      }
      getDragonCategoryList({ eventId }).then(res => {
        if (scene === 'form') this.formCategoryOptions = res.data.list || []
        else this.categoryOptions = res.data.list || []
      })
    },
    loadCategoriesForForm(value) {
      this.form.categoryId = undefined
      this.form.teamId = undefined
      this.form.teamName = ''
      this.form.roundId = undefined
      this.teamOptions = []
      this.formRoundOptions = []
      this.loadCategories(value, 'form')
      this.loadRounds(value, null, 'form')
    },
    handleFormCategoryChange(value) {
      this.form.teamId = undefined
      this.form.teamName = ''
      this.form.roundId = undefined
      this.loadTeamOptions(this.form.eventId, value)
      this.loadRounds(this.form.eventId, value, 'form')
    },
    loadTeamOptions(eventId, categoryId) {
      if (!eventId || !categoryId) {
        this.teamOptions = []
        return Promise.resolve()
      }
      return getDragonResultTeamOptions({ eventId, categoryId }).then(res => {
        this.teamOptions = res.data.list || []
      })
    },
    loadData() {
      this.loading = true
      getDragonResultList({
        page: this.pagination.current,
        pageSize: this.pagination.pageSize,
        eventId: this.query.eventId,
        categoryId: this.query.categoryId,
        roundId: this.query.roundId,
        published: this.query.published
      }).then(res => {
        this.data = res.data.list
        this.pagination.total = res.data.total
      }).finally(() => {
        this.loading = false
      })
    },
    handleTableChange(pagination) {
      this.pagination.current = pagination.current
      this.loadData()
    },
    handleAdd() {
      this.form = {
        eventId: this.query.eventId,
        categoryId: this.query.categoryId,
        roundId: this.query.roundId,
        teamId: undefined,
        teamName: ''
      }
      this.formCategoryOptions = this.categoryOptions.slice()
      this.formRoundOptions = this.roundOptions.slice()
      this.teamOptions = []
      if (this.form.eventId && this.form.categoryId) {
        this.loadTeamOptions(this.form.eventId, this.form.categoryId)
      }
      this.visible = true
    },
    handleEdit(record) {
      this.form = { ...record }
      this.loadCategories(record.eventId, 'form')
      this.loadRounds(record.eventId, record.categoryId, 'form')
      this.loadTeamOptions(record.eventId, record.categoryId)
      this.visible = true
    },
    handleOk() {
      this.$refs.formRef.validate(valid => {
        if (!valid) return
        const selectedTeam = this.teamOptions.find(item => item.teamId === this.form.teamId)
        if (selectedTeam) {
          this.form.teamName = selectedTeam.teamName
        }
        saveDragonResult(this.form).then(() => {
          this.$message.success('保存成功')
          this.visible = false
          this.loadData()
        })
      })
    },
    handleDelete(id) {
      deleteDragonResult({ id }).then(() => {
        this.$message.success('删除成功')
        this.loadData()
      })
    },
    handlePublish(published) {
      if (!this.query.eventId || !this.query.categoryId) {
        this.$message.warning('请先选择赛事和组别')
        return
      }
      publishDragonResult({
        eventId: this.query.eventId,
        categoryId: this.query.categoryId,
        roundId: this.query.roundId,
        published
      }).then(() => {
        this.$message.success(published === 1 ? '发布成功' : '撤回成功')
        this.loadData()
      })
    },
    downloadTemplate() {
      window.open(`${process.env.BASE_URL}templates/dragonboat-result-import-template.xlsx`)
    },
    handleImport({ file, onSuccess, onError }) {
      if (!this.query.eventId || !this.query.categoryId) {
        this.$message.warning('请先选择赛事和组别')
        onError(new Error('未选择赛事和组别'))
        return
      }
      const formData = new FormData()
      formData.append('file', file)
      const query = `eventId=${this.query.eventId}&categoryId=${this.query.categoryId}${this.query.roundId ? `&roundId=${this.query.roundId}` : ''}`
      request({
        url: `/dragonboat/result/import?${query}`,
        method: 'post',
        data: formData,
        headers: { 'Content-Type': 'multipart/form-data' }
      }).then(res => {
        this.$message.success(`导入成功，共 ${res.data.count} 条`)
        this.loadData()
        onSuccess(res)
      }).catch(err => {
        onError(err)
      })
    }
  }
}
</script>
